import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

export default function useSections() {
  const [map, setMap] = useState({});
  useEffect(() => {
    api.get("/sections").then((r) => {
      const m = {};
      (r.data || []).forEach((s) => { m[s.key] = s; });
      setMap(m);
    }).catch(() => {});
  }, []);
  const isVisible = (key) => {
    // default: visible if missing or true
    if (!(key in map)) return true;
    return !!map[key].is_visible;
  };
  return { sections: map, isVisible };
}
